import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setColorFilter, setStatus } from "../features/filter/filterSlice";

const Filter = () => {
  const dispatch = useDispatch();
  const { color, status } = useSelector((state) => state.filter);

  const handleColorFilter = (color) => dispatch(setColorFilter(color));

  const handleCompletedFilter = (status) => {
    dispatch(setStatus(status));
  };
  return (
    <ul className='flex space-x-1 items-center text-xs'>
      <li onClick={() => handleCompletedFilter("all")} className={`cursor-pointer ${status === "all" && "font-bold"}`}>
        All
      </li>
      <li>|</li>
      <li
        onClick={() => handleCompletedFilter("incompleted")}
        className={`cursor-pointer ${status === "incompleted" && "font-bold"}`}
      >
        Incomplete
      </li>
      <li>|</li>
      <li
        onClick={() => handleCompletedFilter("completed")}
        className={`cursor-pointer ${status === "completed" && "font-bold"}`}
      >
        Complete
      </li>
      <li></li>
      <li></li>
      <li
        onClick={() => handleColorFilter("green")}
        className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
          color.indexOf("green") !== -1 && "bg-green-500"
        }`}
      ></li>
      <li
        onClick={() => handleColorFilter("red")}
        className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
          color.indexOf("red") !== -1 && "bg-red-500"
        }`}
      ></li>
      <li
        onClick={() => handleColorFilter("yellow")}
        className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
          color.indexOf("yellow") !== -1 && "bg-yellow-500"
        }`}
      ></li>
    </ul>
  );
};

export default Filter;
